import React, { ReactNode, VFC } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Header from '../../Header';
import Footer from '../../Footer';
import { selectAuth } from '../../../store/modules/Auth/selectors';
import { RootState } from '../../../store/rootState';
import makeStyles from '@material-ui/core/styles/makeStyles';

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;
const Content = styled.div`
  flex: 1 0 auto;
`;

const useStyles = makeStyles((theme) => ({
  footer: {
    flexShrink: 0,
  },
}));

// このコンポーネント自身の型定義
export interface Props {
  children: ReactNode;
  displayFooter: boolean;
}

// dev-694のタスクで作った新しいコンポーネント
// src/front/Layout/AppLayout.jsをベースに作成
// RailsのSSRに依存しないフロントを作成する場合、こちらのコンポーネントを使用する
const BaseLayout: VFC<Props> = ({ children, displayFooter }: Props) => {
  const classes = useStyles();
  const authState = useSelector((state: RootState) => selectAuth(state));

  return (
    <Wrapper>
      <Content>
        <Header {...authState} />
        {children}
      </Content>
      {/* TODO Footerをコーディング規約に則って、新しくコンポーネント定義し直したい */}
      {displayFooter && <Footer classes={{ root: classes.footer }} />}
    </Wrapper>
  );
};

export default BaseLayout;
